export enum PrecheckStatus {
    failed,
    warn,
    success
}
